// AUTOGENERATED
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const ShownSuggestion = x => x;
const newtypeShownSuggestion_ = {Coercible0: () => {}};
const hasFieldShownSuggestion = dictHasField => dictHasField;
const eqShownSuggestion = {eq: x => y => x.hasPhoto === y.hasPhoto && x.productId === y.productId && x.unitPrice === y.unitPrice};
const genericShownSuggestion = {to: x => x, from: x => x};
const showShownSuggestion = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["hasPhoto", v.hasPhoto ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "productId",
            v.productId
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["unitPrice", Data$dMoney$dRounded.toString(v.unitPrice)]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ShownSuggestion"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeShownSuggestion = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "hasPhoto"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "productId"
    })(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordCons({reflectSymbol: () => "unitPrice"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeShownSuggestion = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericShownSuggestion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "ShownSuggestion"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "unitPrice"
    })({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "productId"})({encodeWithOptions: v => Data$dUUID.encodeUUID.encode}))({
      reflectSymbol: () => "hasPhoto"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeShownSuggestion = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericShownSuggestion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ShownSuggestion"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "unitPrice"
  })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "productId"})({decodeWithOptions: v => Data$dUUID.decodeUUID.decode})())({
    reflectSymbol: () => "hasPhoto"
  })({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ShownSuggestion,
  decodeShownSuggestion,
  encodeShownSuggestion,
  eqShownSuggestion,
  genericShownSuggestion,
  hasFieldShownSuggestion,
  newtypeShownSuggestion_,
  showShownSuggestion,
  unscrambleDecodeShownSuggestion
};
